import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortAmount', standalone: true })
export class ShortAmountPipe implements PipeTransform {
  private readonly suffixes = ['', 'k', 'M', 'B', 'T'];

  transform(value: number, currency = '€', decimals = 1): string {
    if (value == null || isNaN(value)) return `${currency}0`;
    if (value === 0) return `${currency}0`;

    const sign = value < 0 ? '-' : '';
    const abs = Math.abs(value);

    if (abs < 1000) {
      return `${sign}${currency}${abs % 1 === 0 ? abs : abs.toFixed(decimals)}`;
    }

    const tier = Math.min(Math.floor(Math.log10(abs) / 3), this.suffixes.length - 1);
    const scaled = abs / Math.pow(1000, tier);
    const formatted = scaled % 1 === 0 ? scaled.toString() : scaled.toFixed(decimals);

    return `${sign}${currency}${formatted}${this.suffixes[tier]}`;
  }
}
